import axios from "axios";
import { BASE_API } from "../shared/constants/app";
//ko phai component nen phai dùng trực tiếp store
import store from "../redux-setup/store";
import { refreshToken } from "./Api";
import { updateAccessToken } from "../redux-setup/reducers/auth";
const Http = axios.create({
  baseURL: BASE_API,
  withCredentials: true, //mới cho phép Browser gửi cookie
  //vì axios ko tự động gửi cookie
});

Http.interceptors.request.use(
  //gui thanh cong
  async (config) => {
    // console.log("Request >> config");
    // console.log(config);
    //config luôn
    //config là yếu tố mấu chốt của interceptors
    const state = store.getState(); //cu phap
    const auth = state?.auth;
    const login = auth?.login;
    if (login.logged) {
      const accessToken = login.currentCustomer.accessToken;
      //   console.log(`accessToken::: ${accessToken}`);

      config.headers["token"] = `Bearer ${accessToken}`; //authoration
    }

    return config;
  },
  //gui that bai
  async (error) => {
    // console.log("Request --> error.response.config");
    // console.log(error.response.config);
    //error.response.config
    return Promise.reject(error); //cú pháp
  }
);
//-----------------------------------------------
Http.interceptors.response.use(
  //nhận thành công: ko cần xử lý
  async (response) => {
    //response.config
    // console.log("Response >>> response.config");
    // console.log(response.config);

    return response;
  },
  //có lỗi trả về: cần xử lý
  async (error) => {
    //error.response.config
    const response = error.response;
    // console.log("Response -->> error.response.config");
    // console.log(response.config);

    if (
      response.data === "Authentication required 02 (accessToken fail or error)"
      // Authentication required 02 (token hết hạn)"
    ) {
      if (response.config.url.indexOf("/customer/refreshtoken") >= 0) {
        // console.log("điểm mấu chốt ở config");
        // console.log(response.config);
        // console.log("error full response");
        return error;
      }
      //trong thằng config
      //.indexOf == vị trí thứ 2 ở trong mảng

      // console.log("start");
      const data = (await refreshToken()).data;
      // const data1 = await refreshToken();
      // const data = data1.data; //Hiếu dùng _retry
      // console.log("response after refreshToken >>> data");
      // console.log(data1);
      // console.log("end");
      const newAccessToken = data.accessToken;
      // dùng async/await rồi thì ko cần phải kiểm tra data?.accessToken
      // console.log(`newAccessToken::: ${newAccessToken}`);
      store.dispatch(updateAccessToken({ newAccessToken }));
      // đính newAccessToken vào headers
      response.config.headers["token"] = `Bearer ${newAccessToken}`;
      //  trả lại config mới cho Http
      return Http(response.config);
    }
    return Promise.reject(error);
  }
);
export default Http;
